<template>
    <div data-component="OrderDetailsReceiptButtons"
         class="order-details-receipt-buttons mt-1">
        <div v-if="showTicketButtons"
             class="btn-row">
            <button class="btn btn-primary"
                    :disabled="!isOnline || !!isPrinting"
                    @click.prevent="printIndividualTickets">
                <i class="fa-fw fa-solid"
                   :class="isPrinting ? 'fa-spinner fa-spin' : 'fa-ticket-simple'"></i>
                <span>{{ l('ORDER_PRINTING.PRINT_INDIVIDUAL_TICKETS_BTN_TEXT') }}</span>
            </button>
        </div>

        <div v-if="showTicketButtons"
             class="btn-row">
            <button class="btn btn-primary"
                    :disabled="isPrinting"
                    @click.prevent="printGroupTickets">
                <i class="fa-fw fa-solid"
                   :class="isPrinting ? 'fa-spinner fa-spin' : 'fa-tickets-simple'"></i>
                <span>{{ l('ORDER_PRINTING.PRINT_GROUP_TICKETS_BTN_TEXT') }}</span>
            </button>
        </div>

        <div v-if="showGiftAidDeclarationButton"
             class="btn-row">
            <button class="btn btn-primary"
                    :disabled="isPrinting"
                    @click.prevent="printGiftAidDeclaration">
                <i class="fa-fw fa-solid"
                   :class="isPrinting ? 'fa-spinner fa-spin' : 'fa-hand-holding-heart'"></i>
                <span>{{ l('ORDER_PRINTING.PRINT_GIFT_AID_BTN_TEXT') }}</span>
            </button>
        </div>

        <!-- If there was an error loading tax data, show an error message -->
        <div v-if="taxLoadError"
             class="alert alert-danger">
            {{ l('TAX.TAX_RECEIPT_UNAVAILABLE__LOAD_ERROR') }}
            <small v-if="taxLoadError.message"
                   class="block">{{ taxLoadError.message }}</small>
        </div>
        <!-- Fall back to the assumed reason tax was not loaded if we don't know the error -->
        <div v-else-if="taxEnabled && taxReceiptUnavailableReason"
             class="alert alert-warning">
            {{ l('TAX.TAX_RECEIPT_UNAVAILABLE__' + taxReceiptUnavailableReason) }}
        </div>

        <div class="btn-row">
            <button class="btn btn-info"
                    :disabled="isPrinting"
                    :class="{'visually-disabled': !enableReceiptButton}"
                    @click.prevent="printReceipt(false)">
                <i class="fa-fw fa-solid"
                   :class="isPrinting ? 'fa-spinner fa-spin' : 'fa-print'"></i>
                <span>{{ printReceiptLabel }}</span>
            </button>
        </div>

        <div v-if="showTaxReceiptButton"
             class="btn-row">
            <button class="btn btn-info"
                    :disabled="isPrinting"
                    :class="{'visually-disabled': !enableTaxReceiptButton}"
                    @click.prevent="printReceipt(true)">
                <i class="fa-fw fa-solid"
                   :class="isPrinting ? 'fa-spinner fa-spin' : 'fa-print'"></i>
                <span>{{ printTaxReceiptLabel }}</span>
            </button>
        </div>

        <div class="btn-row">
            <button v-if="emailReceiptButtonVisible"
                    class="btn btn-info"
                    :class="[
                        emailReceiptSent ? 'btn-success active' : 'btn-info'
                    ]"
                    @click.prevent="emailReceipt">
                <i class="fa-fw fa-solid"
                   :class="emailReceiptSent ? 'fa-check' : 'fa-envelope'"></i>
                <span>{{ l('ORDER_PRINTING.EMAIL_RECEIPT_BTN_TEXT') }}</span>
            </button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { OrderPrintingMixin } from '@/epos/vue/mixins/OrderReceiptMethods/OrderPrintingMixin';

export default {
    mixins: [
        OrderPrintingMixin,
    ],

    props: {
        order: {
            type: Object,
            required: true,
        },

        taxLoadError: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {

        };
    },

    computed: {
        ...mapState(['isOnline']),
    },
};
</script>
